
import 'babel-polyfill';
import { polyfill as PromisePolyfill } from 'es6-promise';
import 'whatwg-fetch';
import 'custom-event-polyfill';
import 'url-search-params-polyfill';
PromisePolyfill()
import * as i18next from 'i18next'
import * as resources from './components/portal/locales'
  
import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Models from "./generated_models"
import * as GeneratedApi from "./generated_api"
import { stateful, Action, nothing, any, AsyncState, loadingAsyncState, async } from "widgets-for-react";
import { AppState, LoginState, isResendActivationState } from "./components/portal/state";
import { login_widget } from "./components/portal/login";
import * as PortalApi from "./portal_generated_api"
import { State, page_when_custom_routes_unauthorized, PortalRouteParams, custom_routes_unauthorized, application, custom_routes_authorized, ExtraUserInfo } from "./components/portal_client";
import { stateZero } from "./components/portal_utils/state_zero";
import { rendered_object } from "./components/portal_utils/renderer";
import { api_object } from "./components/portal_utils/api";
import { events_object } from "./components/portal_utils/events";
import { get_session, set_session } from "./components/portal_utils/session_utils";
import { get_application } from "./components/portal_utils/application";
import { router_events_handler } from "./components/portal_utils/router_events";
import { application_zero } from "./components/portal_utils/application_zero";

i18next.init({
  lng: 'en',
  resources
})

export let initial_state:LoginState<State, ExtraUserInfo> = {
  status:"logged out",
  login_data: {
                username:"",
                password:"",
                show_password:false
              }
}

export type SessionCheckState = 
  {kind:"app", value:AppState<State, PortalRouteParams, ExtraUserInfo>} 
  | {kind:"session check", value:AsyncState<"valid"|"invalid">}


export let portal_to = (slug:string, target_element_id:string, project_name: string, current_Admin:Models.Admin, current_User:Models.User
) => {
  const info = get_session()
  const logged_out_state: LoginState<State, ExtraUserInfo> = {
    status: "logged out",
    login_data: {
      username: "",
      password: "",
      show_password: false,
    }
  }
  const user_info_state: LoginState<State, ExtraUserInfo> =
    info.v.kind == "l"
      ? logged_out_state
      : {
          status: "logged in",
          appState: stateZero,
          user: info.v.v.user,
          session: info.v.v.session,
          role: info.v.v.role,
        }
  const initial_state : SessionCheckState = info.v.kind == "l"
    ? {kind: "app", value: application_zero(user_info_state)}
    : {kind: "session check", value: loadingAsyncState(() => info.v.kind == "r" && PortalApi.is_session_valid(info.v.v.user.email, info.v.v.session, info.v.v.role))}
  GeneratedApi.project_name_set(project_name);
  ReactDOM.render(
    stateful<SessionCheckState>()(s0 =>
      any<Action<SessionCheckState>>()([
        s0.kind == "app" ?
          login_widget<State, PortalRouteParams, ExtraUserInfo>({
            api: api_object,
            ps_r: rendered_object({
              initial_state: s0.value.get_initial_state(),
              get_session,
              without_browserRouter: false 
            }),
            events: events_object,
            application: get_application(application("")),
            application_router_switch: router_events_handler,
            custom_auth_routes: custom_routes_authorized,
            custom_unauth_routes: custom_routes_unauthorized,
            initial_state: s0.value.get_initial_state(),
            rootpath:"",
            get_session:get_session,
            set_session:set_session,
            login_decorator: w => page_when_custom_routes_unauthorized(s0.value, w),
          })(s0.value).map<Action<SessionCheckState>>(a => s => s.kind != "app" ? s : ({...s, value:a(s.value)}))
        : async<"valid"|"invalid">(_ => nothing())(s0.value).map<Action<SessionCheckState>>(a => s => {
          if(s.kind == "app") return s
          const remote_res = a(s.value)
          if (remote_res.kind == "loaded") {
            if (remote_res.value == "valid") {
              return {kind: "app", value: application_zero(user_info_state)}
            }
            set_session(undefined, undefined, undefined)
            return {kind: "app", value: application_zero(logged_out_state)}
          }
          return {...s, value: remote_res}
        })
    ]).map<SessionCheckState>(a => {
      const newS = a(s0)
      if (newS.kind == "app" && !newS.value.login) {
        newS.value.login = s0.kind == "app" ? s0.value.login : undefined
      }
      return newS
    }))
    (initial_state).run(_ => null),
    document.getElementById(target_element_id)
  )
}